import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-question-circle" }, null, -1)

import { translation } from '../../../lang/Translation';
import { DialogHandler } from '../../dialog/DialogHandler';

export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialButton',
  setup(__props) {

const tutorialButtonTitle = translation.to("チュートリアル",'tutorial');
const openTutorial = () => DialogHandler.showTutorialDialog();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-default",
    onClick: openTutorial
  }, [
    _hoisted_1,
    _createElementVNode("span", null, _toDisplayString(_unref(tutorialButtonTitle)), 1)
  ]))
}
}

})